import { ErrorType } from '@lib/interfaces/errors';

/**
 * レスポンス用のエラー定義
 */
export class ResponseError extends Error {
  /**
   * @var {ErrorType} エラータイプ
   */
  protected errType: ErrorType = ErrorType.SYSTEM;

  /**
   * @var {string} エラーメッセージID
   */
  protected errId: string = '';

  /**
   * 構築関数
   * @param errType エラータイプ
   * @param errId エラーメッセージID
   */
  constructor(errType: ErrorType, errId: string) {
    super();
    this.name = this.toString();
    this.errType = errType;
    this.errId = errId;
    Error.captureStackTrace(this, ResponseError);
  }

  /**
   * エラータイプを取得
   * @returns {string}
   */
  public getErrType(): ErrorType {
    return this.errType;
  }

  /**
   * エラーメッセージIDを取得
   * @returns {string}
   */
  public getErrId(): string {
    return this.errId;
  }

  /**
   * エラーの情報を取得
   */
  override toString(): string {
    return `[ResponseError]: type:${this.getErrType()}, id:${this.getErrId()};`;
  }
}
